import { useApp } from "../store.jsx";
import { StatusPill } from "./Pill.jsx";

// Checkbox list of OTHER tasks in the same department; toggling commits via
// patchTask. The Gantt already draws task→task arrows from ganttDeps.
export default function TaskDeps({ task }) {
  const { tasks, patchTask } = useApp();
  if (!task || !tasks) return null;

  const candidates = tasks
    .filter(t => t.deptShort === task.deptShort && t.id !== task.id)
    .sort((a, b) => (a.sortOrder - b.sortOrder) || (a.deptNum - b.deptNum));

  const selected = new Set(task.ganttDeps || []);

  const toggle = (id) => {
    const next = new Set(selected);
    if (next.has(id)) next.delete(id); else next.add(id);
    patchTask(task.id, { ganttDeps: [...next] });
  };

  if (candidates.length === 0) {
    return (
      <div>
        <h3 style={{margin:"0 0 6px"}}>Depends on other tasks</h3>
        <div className="sub">No other tasks in {task.deptShort} to link to yet.</div>
      </div>
    );
  }

  return (
    <div>
      <h3 style={{margin:"0 0 6px"}}>Depends on other tasks</h3>
      <div className="sub" style={{marginBottom:8}}>
        Linked tasks must finish before this one's bar. Drawn as dashed arrows in the Gantt.
      </div>
      <ul className="gate-deps">
        {candidates.map(t => {
          const pending = t.status !== "Live";
          return (
            <li key={t.id}>
              <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer"}}>
                <input type="checkbox" checked={selected.has(t.id)}
                       onChange={() => toggle(t.id)}
                       style={{accentColor:"var(--link)"}}/>
                <span className="sub" style={{minWidth:36}}>#{t.briefNo}</span>
                <span style={{flex:1}}>{t.title}</span>
                <StatusPill status={t.status}/>
                {pending && <span className="sub" style={{color:"#fbbf24"}}>pending</span>}
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
